import React from 'react';
import "./Product.css"

const Product = (props) => {
    const { name, price, item, flight, Destination, Airlines, img } = props.ticket
    return (
            <div class="col-lg-4 ">
                <div className="card mb-3">
              
                        <img src={img} class="card-img-top card_img" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title">{name.slice(0, 50)}</h6>

                            <table class="table">

                                <tbody>
                                    <tr className="price">
                                        <th scope="row" >Price</th>
                                        <th>:</th>
                                        <th> {price}</th>
                                    </tr>
                                    <tr>
                                        <th>Flight</th>
                                        <th>:</th>
                                        <td>{flight}</td>
                                    </tr>
                                    <tr>
                                        <th>Destination</th>
                                        <th>:</th>
                                        <td>{Destination}</td>
                                    </tr>
                                    <tr>
                                        <th>Item</th>
                                        <th>:</th>
                                        <td>{item}</td>
                                    </tr>
                                    <tr>
                                        <th>Air-lines</th>
                                        <th>:</th>
                                        <td>{Airlines}</td>
                                    </tr>

                                </tbody>
                            </table>
                            <div className="text-center">
                            <button className="btn-warning btn-sm btn" onClick={()=> props.hanleAddtoCart(props.ticket)}> <i class="far fa-cart-plus    "></i> Bye Ticket</button>
                            </div>
                           
                        </div>
                    </div>
                          
                </div>
               
    );
};

export default Product;